import type { Property } from '@adc/sdk/types'
// @ts-ignore esModuleInterop
import React, { createContext, useContext, ReactNode } from 'react'
import { toggleSaveProperty as toggleSavePropertyFunction } from '../utils/property'

export type PropertyPageActionsType = {
  toggleSaveProperty: ReturnType<typeof toggleSavePropertyFunction>
}
const PropertyContext = createContext<
  | {
      property: Property
      propertyActions?: PropertyPageActionsType
    }
  | undefined
>(undefined)

export const usePropertyContext = () => {
  const context = useContext(PropertyContext)
  if (context === undefined) {
    throw new Error(
      'usePropertyContext must be used within a PropertyContextProvider'
    )
  }
  return context
}

interface PropertyProviderProps {
  children: ReactNode
  property: Property
  propertyActions?: PropertyPageActionsType
}

export const PropertyProvider = ({
  children,
  property,
  propertyActions,
}: PropertyProviderProps) => (
  <PropertyContext.Provider value={{ propertyActions, property }}>
    {children}
  </PropertyContext.Provider>
)

export default PropertyProvider
